import { ReactComponent as UnavailableSeatIcon } from '@eti/assets/icons/c_flat-seat-unavailable.svg';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const UnavailableSeat = () => /*#__PURE__*/_jsx("div", {
  className: rowItemSize,
  children: /*#__PURE__*/_jsx(UnavailableSeatIcon, {})
});
export default UnavailableSeat;
//# sourceMappingURL=UnavailableSeat.js.map